import { Model } from '../../models/Model'

const mutations = {
  setCurrentModel(state: any, model: Model) {
    state.currentModel = model
    state.currentModelId = model.id
  },
  setCurrentModelId(state: any, modelId: string) {
    state.currentModelId = modelId
  },
  addCarouselModel(state: any, model: Model) {
    state.carouselModels.push(model)
  },
  clearCarouselModels(state: any) {
    state.carouselModels = []
  },
  addYearModel(state: any, model: Model) {
    state.yearModels.push(model)
  },
  clearYearModels(state: any) {
    state.yearModels = []
  },
  loading(state: any, loading: boolean) {
    state.loading = loading
  },
  clearCurrentModel(state: any) {
    state.currentModel = null
    state.currentModelId = ''
  }
}

const getters = {
  currentModel(state: any) {
    return state.currentModel
  },
  currentModelId(state: any) {
    return state.currentModelId
  },
  carouselModels(state: any) {
    return state.carouselModels
  },
  yearModels(state: any) {
    return state.yearModels
  },
  loading(state: any) {
    return state.loading
  }
}

const actions = {
  async reloadCarouselModels(context : any, args : any) {
    context.commit('loading', true)

    context.commit('clearCarouselModels')
    const res = await Model.getCarouselModels(args.makeId)
    res.forEach((model: Model) => {
      context.commit('addCarouselModel', model)
    })

    context.commit('loading', false)

    return Promise.resolve()
  },
  async reloadYearModels(context : any, args : any) {
    context.commit('loading', true)

    context.commit('clearYearModels')
    const res = await Model.getModels(args.makeId, args.yearId)
    res.forEach((model: Model) => {
      context.commit('addYearModel', model)
    })

    context.commit('loading', false)

    return Promise.resolve()
  },
}

const state = () => ({
  currentModel: null as Model,
  currentModelId: '' as string,
  yearModels: [] as Model[],
  carouselModels: [] as Model[],
  loading: false as boolean
})

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};
